import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";

import { NFCeFiltrar } from "src/services/Fiscal.Service";
import { showToast } from "src/componentes";
import { MapearErrosServidor } from "src/hook/Functions";
import { NFCeDto } from "../NFCe.Dto";

const NFCeVisualizaCode = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const [nfce, setNfce] = useState<NFCeDto | undefined>(location.state?.nfce);
  const [loading, setLoading] = useState(!nfce);
  const [expandedItemIndex, setExpandedItemIndex] = useState<number | null>(null);

  useEffect(() => {
    if (!nfce && id) {
      loadNFCe(Number(id));
    }
  }, [id, nfce]);

  const loadNFCe = async (nfceId: number) => {
    setLoading(true);
    try {
      const response = await NFCeFiltrar({ id: nfceId });
      if (response.data.success && response.data.data.length > 0) {
        setNfce(response.data.data[0]);
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error(error);
      showToast({ message: "Erro ao carregar dados da NFCe", variant: "Danger" });
    } finally {
      setLoading(false);
    }
  };

  const toggleItemExpansion = (index: number) => {
    setExpandedItemIndex(expandedItemIndex === index ? null : index);
  };

  return {
    nfce,
    loading,
    expandedItemIndex,
    toggleItemExpansion,
  };
};

export default NFCeVisualizaCode;
